import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';

class DateTimeInput extends React.Component {

  state = {
    tempValue: null
  };

  onChange = event => {
    const value = event.target.value;
    if (typeof value !== 'string' || !value) {
      return this.setState({
        tempValue: value
      })
    }
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) {
      return this.setState({
        tempValue: value
      });
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return this.setState({
        tempValue: value
      });
    }
    // Only set external once valid
    this.props.onChangeValue(date.getTime());
    this.setState({
      tempValue: null
    });
  };

  getValue() {
    const { tempValue } = this.state;
    if (typeof tempValue === 'string') {
      return tempValue;
    }
    const { value } = this.props;
    if (typeof value !== 'number' || isNaN(value) || value === 0) {
      return '';
    }
    const date = new Date(value);
    const dateString = [
      date.getFullYear(),
      `0${date.getMonth() + 1}`.slice(-2),
      `0${date.getDate()}`.slice(-2)
    ]
      .join('-');
    const timeString = [
      `0${date.getHours()}`.slice(-2),
      `0${date.getMinutes()}`.slice(-2)
    ]
      .join(':');
    return `${dateString}T${timeString}`;
  }

  render() {
    const { onChangeValue, ...rest } = this.props;
    return (
      <Input
        {...rest}
        type="datetime-local"
        value={this.getValue()}
        onChange={this.onChange}
      />
    );
  }

}

DateTimeInput.propTypes = {
  ...Input.propTypes,
  value: PropTypes.number.isRequired,
  onChangeValue: PropTypes.func.isRequired
};

export default DateTimeInput;


// WEBPACK FOOTER //
// ./src/views/common/datetime-input.js